module.exports = __webpack_public_path__ + "static/security1@3x-56817b93baa6d4a777cc3ad31f6b2960.png";